import { render } from "./CreateL2NetworkForm.vue?vue&type=template&id=9c72b9fe&scoped=true"
import script from "./CreateL2NetworkForm.vue?vue&type=script&lang=js"
export * from "./CreateL2NetworkForm.vue?vue&type=script&lang=js"

import "./CreateL2NetworkForm.vue?vue&type=style&index=0&id=9c72b9fe&lang=less&scoped=true"

import exportComponent from "/home/runner/work/cloudstack/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c72b9fe"]])

export default __exports__